import styled from "styled-components";
import { space } from "styled-system";

export const StyledSvg = styled.svg`
  ${space}
`;
